<template>
  <v-card>
    <v-container style="max-width: 1500px">
      <v-row v-if="role == 3 || smsRef == 'blueberry'">
        <v-col cols="12">
          <v-toolbar color="secondary" flat dense>
            <v-toolbar-title>Dashboard</v-toolbar-title>
          </v-toolbar>
        </v-col>

        <!-- 
        <v-col cols="12" xs="12" sm="4" md="4">
          <DashPicker
            outlined
            @date="setDate"
            :fieldName="startField"
            :myDate="record.StartDate"
            :title="`From`"
          ></DashPicker>
        </v-col>

        <v-col cols="12" xs="12" sm="4" md="4">
          <DashPicker
            outlined
            @date="setDate"
            :fieldName="endField"
            :myDate="record.EndDate"
            :title="`To`"
          ></DashPicker>
        </v-col>

        <v-col cols="12" xs="12" sm="4" md="4">
          <v-btn
            class="ml-2 dash-btn"
            dense
            color="accent"
            @click="queryData"
            :loading="loader"
            >Filter</v-btn
          >
        </v-col> -->

        <!-- <v-col cols="6" xs="6" sm="3" md="3">
          <v-card tile>
            <v-alert type="info" tile icon="mdi-briefcase-check"
              >Monthly Sales Count</v-alert
            >
            <span class="cardText">
              Total Count: {{ dashData.SalesCount }}</span
            >
          </v-card>
        </v-col> -->

        <!-- first -->
        <!-- <v-col cols="6" xs="6" sm="3" md="3">
          <v-card tile>
            <v-alert type="success" tile color="pink" icon="mdi-cart-variant"
              >Montly Sales</v-alert
            >
            <span class="cardText"
              >Ksh {{ dashData.TotalSales.toLocaleString() }}</span
            >
          </v-card>
        </v-col> -->
        <!-- end -->

        <!-- first -->
        <!-- <v-col cols="6" xs="6" sm="3" md="3">
          <v-card tile>
            <v-alert type="warning" tile icon="mdi-calendar-check"
              >Monthly Purchases</v-alert
            >
            <span class="cardText"
              >Ksh {{ dashData.TotalPurchases.toLocaleString() }}</span
            >
          </v-card>
        </v-col> -->
        <!-- end -->

        <!-- first -->
        <!-- <v-col cols="6" xs="6" sm="3" md="3">
          <v-card tile>
            <v-alert type="success" tile icon="mdi-briefcase-check"
              >Monthly Expenditure</v-alert
            >
            <span class="cardText"
              >Ksh {{ dashData.TotalExpenses.toLocaleString() }}</span
            >
          </v-card>
        </v-col> -->
        <!-- end -->
      </v-row>

      <v-row>
        <v-col cols="12" xs="12" sm="6" md="12">
          <v-toolbar flat dense color="secondary">
            <v-toolbar-title>Weekly Sales</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="resetLoader">Reset Loader </v-btn>
          </v-toolbar>

          <!-- sms -->

          <v-btn color="primary" text @click="sendSms">
            Send Sms
          </v-btn>

          <line-chart :data="dashData.WeeklySales"></line-chart>
        </v-col>

        <!-- <v-col cols="12">
          <v-btn color="accent" text @click="fixSaleDuplicates">Fix Sale Duplicates</v-btn>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>

          <v-data-table :headers="headers" :items="duplicates" :search="search" :items-per-page="1000">

            </v-data-table>
        </v-col> -->
      </v-row>

      <snackbar ref="snackbar"></snackbar>
    </v-container>
  </v-card>
</template>


<script>
export default {
  components: {},
  computed: {
    role() {
      return localStorage.getItem("userRole");
    },
  },
  data() {
    return {
      datacollection: {},
      loader: false,
      smsRef: null,
      loading: false,
      record: {},
      callsData: [],
      search: null,
      dashData: {},
      startField: "StartDate",
      endField: "EndDate",
      trueValue: true,
      headers: [
        { text: "Local Id", value: "LocalId" },
        { text: "Subscriber Id", value: "SubscriberId" },
      ],
      duplicates: [],
    };
  },
  methods: {
    sendSms() {
     // const self = this;
      this.$store
        .dispatch("get", `/send-sms`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData) {
              console.log(res.ResponseData, " res ");
              // self.smsRef = res.ResponseData.smsRef;
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    deleteData() {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/reset-account`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show("Reset Done", "blue");
          } else {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    queryData() {
      const data = this.record;
      const url = `/dashboard`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.dashData = res.ResponseData;
            self.callsData = [
              { name: "Sales", data: res.ResponseData.callsData },
              { name: "Payments", data: res.ResponseData.salesData },
            ];
          }
          self.loader = false;
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getInitialData() {
      const data = {};
      const url = `/dashboard`;
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.dashData = res.ResponseData;
            self.callsData = [
              { name: "Sales", data: res.ResponseData.callsData },
              { name: "Payments", data: res.ResponseData.ordersData },
            ];
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(data) {
      this.record = { ...this.record, [data.fieldName]: data.date };
    },
    resetLoader() {
      this.$store.commit("loader", false);
      this.$store.commit("btnLoader", false);
      this.$refs.snackbar.show("Done", "green");
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData) {
              self.smsRef = res.ResponseData.smsRef;
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    fetchSaleDuplicates() {
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", `/fetch-sale-duplicates`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData) {
              self.duplicates = res.ResponseData;
              self.loader = false;
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    fixSaleDuplicates() {
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", `/fix-sale-duplicates`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData) {
              self.loader = false;
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    // this.fetchSaleDuplicates();
    // this.getInitialData();
    // this.getGenSettings();
  },
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}

.cardText {
  font-weight: bold;
  font-size: 18px;
  padding: 12px;
  color: #757575;
}

.dash-btn {
  margin-top: -5px;
}
</style>